import { render, staticRenderFns } from "./choice_location_modal.vue?vue&type=template&id=0e527b43&scoped=true&"
import script from "./choice_location_modal.vue?vue&type=script&lang=js&"
export * from "./choice_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e527b43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e527b43')) {
      api.createRecord('0e527b43', component.options)
    } else {
      api.reload('0e527b43', component.options)
    }
    module.hot.accept("./choice_location_modal.vue?vue&type=template&id=0e527b43&scoped=true&", function () {
      api.rerender('0e527b43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/choice/location/choice_location_modal.vue"
export default component.exports